/////////////////// ※주의: 루쿠쿠 편집 금지
/////////////////// ※warning: do not edit this file in lukuku

///////////////////  살로몬 전용 퍼블리셔 커스텀 스크립트  ///////////////////
///////////////////  salomon only publisher custom script  ///////////////////

///////////////////  컬렉션 전용  ///////////////////
$(function(){
  // 261026 윈터다운 기획전 1차
  if ($('#htmlCustom261022').length) {
    gsap.registerPlugin(ScrollTrigger);
    let layoutRefreshTimer;
    const scheduleLayoutRefresh = () => {
      clearTimeout(layoutRefreshTimer);
      layoutRefreshTimer = setTimeout(() => ScrollTrigger.refresh(), 200);
    };
    new ResizeObserver(scheduleLayoutRefresh).observe(document.body);
    if (document.fonts) document.fonts.ready.then(scheduleLayoutRefresh);

    const mm = window.matchMedia('(max-width: 768px)').matches;

    // Hero 인터랙션
    const heroTl = gsap.timeline({ paused: true });
    const heroBg = document.querySelector('.wd__hero__bg');
    const heroModel = document.querySelector('.wd__hero__model');
    const heroTtl = document.querySelector('.wd__hero__ttl h1');
    const heroDimmed = document.querySelector('.wd__hero__dimmed');

    gsap.set(heroBg, { yPercent: -35 });

    if (mm) {
      heroTl
        .to(heroBg, { yPercent: -25, duration: 2, ease: 'none' }, 0)
        .from(heroDimmed, { autoAlpha: 0, duration: 0.8, ease: 'none' }, 0)
        .from(heroModel, { autoAlpha: 0, duration: 0.6 }, 0.4)
        .from(heroModel, { yPercent: 3, duration: 1, ease: 'none' }, 0.4)
        .from(heroTtl, { autoAlpha: 0, filter: 'blur(10px)', duration: 1 }, 1);
    } else {
      heroTl
        .to(heroBg, { yPercent: -25, duration: 2, ease: 'none' }, 0)
        .from(heroModel, { autoAlpha: 0, duration: 0.6 }, 0.4)
        .from(heroModel, { yPercent: 3, duration: 1, ease: 'none' }, 0.4)
        .from(heroTtl, { autoAlpha: 0, filter: 'blur(10px)', duration: 1 }, 1)
        .from(heroDimmed, { autoAlpha: 0, duration: 1.2, ease: 'none' }, 1);
    }

    const heroImg = document.querySelector('.wd__hero__bg img');
    const playHero = () => gsap.delayedCall(0, () => heroTl.play());
    if (heroImg && !(heroImg.complete && heroImg.naturalWidth)) heroImg.addEventListener('load', playHero, { once: true });
    else playHero();

    // CTA 마커 & 이미지 인터랙션
    const markers = gsap.utils.toArray('.cta__marker');
    const halves = gsap.utils.toArray('.wd__campaign__half');
    const intros = new WeakMap();
    const getTip = (marker) => marker.querySelector('a');

    const openTip = (marker) => {
      marker.classList.add('is-open');
      gsap.to(getTip(marker), { autoAlpha: 1, scale: 1, duration: 0.45, ease: 'power2.out', overwrite: true });
    };
    const closeTip = (marker) => {
      marker.classList.remove('is-open');
      gsap.to(getTip(marker), { autoAlpha: 0, scale: 0.6, duration: 0.3, ease: 'power2.in', overwrite: true });
    };
    const openHalf = (half) => {
      half.classList.add('is-open');
      half.setAttribute('aria-expanded', 'true');
      half.querySelectorAll('.cta__marker').forEach(openTip);
    };
    const closeHalf = (half) => {
      half.classList.remove('is-open');
      half.setAttribute('aria-expanded', 'false');
      half.querySelectorAll('.cta__marker').forEach(closeTip);
    };
    const toggleHalf = (half) => {
      // 인트로 도중 누르면 인트로를 끝내고(콜백 생략) 곧바로 수동 모드로 전환
      const intro = intros.get(half);
      if (intro && intro.isActive()) intro.progress(1, true);
      half.classList.contains('is-open') ? closeHalf(half) : openHalf(half);
    };

    // 키보드로도 열 수 있도록 마커가 있는 half를 버튼처럼 노출
    halves.forEach((half) => {
      if (!half.querySelector('.cta__marker')) return;
      half.setAttribute('role', 'button');
      half.setAttribute('tabindex', '0');
      half.setAttribute('aria-expanded', 'false');
      half.setAttribute('aria-label', '상품 정보 보기');
      half.addEventListener('keydown', (e) => {
        if (e.target !== half) return;
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          halves.forEach((h) => h !== half && h.classList.contains('is-open') && closeHalf(h));
          toggleHalf(half);
        } else if (e.key === 'Escape') closeHalf(half);
      });
    });

    markers.forEach((marker) => {
      gsap.set(marker, { autoAlpha: 0 });
      gsap.set(getTip(marker), { autoAlpha: 0, scale: 0.6 });
      gsap.set(marker.querySelector('.cta__marker--wave'), { opacity: 0 });
    });

    // 누른 half는 열고(열려 있으면 닫고), 그 외 영역을 누르면 열려 있던 half는 닫음
    document.addEventListener('click', (e) => {
      if (e.target.closest('.cta__marker a')) return;
      const hit = e.target.closest('.wd__campaign__half');
      halves.forEach((half) => half !== hit && half.classList.contains('is-open') && closeHalf(half));
      if (hit && hit.querySelector('.cta__marker')) toggleHalf(hit);
    });

    gsap.utils.toArray('.wd__campaign__half').forEach((half) => {
      gsap.from(half, { autoAlpha: 0.5, duration: 0.6, scrollTrigger: { trigger: half, start: 'top 65%', once: true } });

      const halfMarkers = gsap.utils.toArray('.cta__marker', half);
      if (!halfMarkers.length) return;
      const waves = halfMarkers.map((m) => m.querySelector('.cta__marker--wave'));
      gsap.fromTo(waves, { scale: 1, opacity: 0.6 }, { scale: 3, opacity: 0, duration: 1.2, stagger: 0.1, ease: 'power1.out', repeat: -1 }, '<');

      const intro = gsap.timeline({ scrollTrigger: { trigger: half, start: 'center 90%', once: true } });
      intro
        .to(halfMarkers, { autoAlpha: 1, duration: 0.6, ease: 'power2.out' })
        .call(() => openHalf(half), null, 0.6)
        .call(() => closeHalf(half), null, 2.4);

      intros.set(half, intro);
    });

    // 프로필 썸네일: 진입 시 순차 fade-up 후 영상을 한 개씩 재생하고, 나머지는 정지 프레임으로 둠
    const profileList = document.querySelector('.wd__intro__profile');
    const profiles = gsap.utils.toArray('.wd__intro__profile li');
    const profileVideos = profiles.map((li) => li.querySelector('video'));
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const PROFILE_PLAY_SEC = 3;
      let current = -1;
      let ready = false;

      const playAt = (i) => {
        const prev = current;
        current = i;
        profiles.forEach((li, idx) => li.classList.toggle('is-active', idx === i));
        if (prev > -1 && prev !== i) {
          profileVideos[prev].pause();
          profileVideos[prev].currentTime = 0.001;
        }
        profileVideos[i].play().catch(() => {});
      };

      // 재생 전에도 첫 프레임이 보이도록(iOS는 currentTime을 지정해야 그려짐)
      profileVideos.forEach((video, i) => {
        video.loop = false;
        // iOS Safari는 preload를 무시해 play() 전까지 영상을 불러오지 않아(loadedmetadata도 미발생) 재생 순서를 기다리는 영상이 검게 보임 → #t 미디어 프래그먼트로 첫 프레임 로드를 강제
        const source = video.querySelector('source');
        if (source && !source.getAttribute('src').includes('#t=')) {
          source.setAttribute('src', `${source.getAttribute('src')}#t=0.001`);
          video.preload = 'metadata';
          video.load();
        }
        video.addEventListener('loadedmetadata', () => (video.currentTime = 0.001));
        const next = () => i === current && playAt((i + 1) % profileVideos.length);
        video.addEventListener('ended', next);
        video.addEventListener('timeupdate', () => video.currentTime >= PROFILE_PLAY_SEC && next());
      });

      const resume = () => ready && (current < 0 ? playAt(0) : profileVideos[current].play().catch(() => {}));
      const pause = () => current > -1 && profileVideos[current].pause();

      const profileTrigger = ScrollTrigger.create({
        trigger: profileList,
        start: 'top bottom',
        end: 'bottom top',
        onEnter: resume,
        onEnterBack: resume,
        onLeave: pause,
        onLeaveBack: pause,
      });

      gsap
        .timeline({ scrollTrigger: { trigger: profileList, start: 'top 90%', once: true } })
        .from(profileList, { autoAlpha: 0, y: 40, duration: 0.6, ease: 'power2.out' })
        .call(
          () => {
            ready = true;
            if (profileTrigger.isActive) resume();
          },
          null,
          0
        );
    }

    // 탭 클릭 시 해당 셰이퍼 영역으로 스무스 스크롤, 스크롤 위치에 따라 active 동기화
    const tabItems = gsap.utils.toArray('.wd__campaign__tab li');
    const tabEl = document.querySelector('.wd__campaign__tab');
    let isTabScrolling = false;
    let tabScrollTween;
    const setActiveTab = (key) => tabItems.forEach((li) => li.classList.toggle('active', li.dataset.target === key));

    // 탭이 화면 상단에 닿으면 fixed로 고정
    ScrollTrigger.create({
      trigger: tabEl,
      start: 'top top',
      endTrigger: '.wd__campaign',
      end: () => `bottom top+=${tabEl.offsetHeight}`,
      pin: true,
      pinSpacing: false,
      invalidateOnRefresh: true,
    });

    const stopTabScroll = () => tabScrollTween && tabScrollTween.kill();
    ['wheel', 'touchstart'].forEach((evt) => window.addEventListener(evt, stopTabScroll, { passive: true }));

    tabItems.forEach((li) => {
      li.addEventListener('click', () => {
        const area = document.querySelector(`.wd__campaign__area[data-shapers="${li.dataset.target}"]`);
        if (!area) return;
        const html = document.documentElement;
        const y = area.getBoundingClientRect().top + window.scrollY - tabEl.offsetHeight;
        const done = () => {
          isTabScrolling = false;
          html.style.scrollBehavior = '';
        };

        isTabScrolling = true;
        setActiveTab(li.dataset.target);
        html.style.scrollBehavior = 'auto';
        stopTabScroll();
        tabScrollTween = gsap.to(window, {
          scrollTo: { y, autoKill: false },
          duration: 0.9,
          ease: 'power2.inOut',
          overwrite: true,
          onComplete: done,
          onInterrupt: done,
        });
      });
    });

    gsap.utils.toArray('.wd__campaign__area').forEach((area) => {
      ScrollTrigger.create({
        trigger: area,
        start: 'top 50%',
        end: 'bottom 50%',
        onToggle: (self) => self.isActive && !isTabScrolling && setActiveTab(area.dataset.shapers),
      });
    });

    // 좌우로 자동으로 흐르는 스와이프 & 수동 컨트롤
    const TRACK_VW_PER_SEC = 6.25;
    gsap.utils.toArray('.wd__track').forEach((track) => {
      let resumeTimer;
      let running = true;

      const swiper = new Swiper(track, {
        grabCursor: true,
        slidesPerView: 'auto',
        loop: true,
        loopedSlides: 5,
        freeMode: true,
        freeModeMomentum: false,
        on: {
          touchStart() {
            running = false;
            clearTimeout(resumeTimer);
          },
          touchEnd() {
            clearTimeout(resumeTimer);
            resumeTimer = setTimeout(() => {
              swiper.$wrapperEl.transition(0);
              running = true;
            }, 800);
          },
        },
      });
      swiper.$wrapperEl.transition(0);

      gsap.ticker.add((time, deltaTime) => {
        if (!running) return;
        const count = swiper.slides.length - swiper.loopedSlides * 2;
        const start = swiper.slidesGrid[swiper.loopedSlides];
        const loopWidth = swiper.slidesGrid[swiper.loopedSlides + count] - start;

        const pxPerMs = (window.innerWidth * TRACK_VW_PER_SEC) / 100 / 1000;
        let pos = -swiper.translate + pxPerMs * Math.min(deltaTime, 50);
        if (pos >= start + loopWidth) pos -= loopWidth;
        else if (pos < start) pos += loopWidth;
        swiper.setTranslate(-pos);
      });
    });

    // 인터뷰 아코디언
    gsap.utils.toArray('.wd__interview').forEach((interview) => {
      const inner = interview.querySelector('.wd__interview__inner');
      const toggle = interview.querySelector('.wd__interview__toggle');
      toggle.setAttribute('aria-expanded', 'false');

      toggle.addEventListener('click', () => {
        const willOpen = !inner.classList.contains('is-open');
        gsap.killTweensOf(inner);
        const from = inner.offsetHeight;
        inner.classList.toggle('is-open', willOpen);
        toggle.classList.toggle('is-open', willOpen);
        inner.style.height = willOpen ? 'auto' : '';
        const to = inner.offsetHeight;

        toggle.textContent = willOpen ? '접기' : '인터뷰 더보기';
        toggle.setAttribute('aria-expanded', String(willOpen));
        gsap.fromTo(inner, { height: from }, { height: to, duration: 0.6, ease: 'power2.inOut', onComplete: () => (inner.style.height = willOpen ? 'auto' : '') });
      });
    });

    const ctaBtns = document.querySelectorAll('.wd__cta');
    ctaBtns.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const target = document.querySelector(btn.getAttribute('href'));
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }


  // 261002 윈터 트레일 기획전
  if ($('#htmlCustom261002').length) {
    gsap.registerPlugin(ScrollTrigger);
    let layoutRefreshTimer;
    const scheduleLayoutRefresh = () => {
      clearTimeout(layoutRefreshTimer);
      layoutRefreshTimer = setTimeout(() => ScrollTrigger.refresh(), 200);
    };
    new ResizeObserver(scheduleLayoutRefresh).observe(document.body);
    if (document.fonts) document.fonts.ready.then(scheduleLayoutRefresh);

    // 여러 섹션에서 반복되는 페이드업 리빌 애니메이션
    function revealAni(containerSelector, childSelector, vars = {}) {
      gsap.utils.toArray(containerSelector).forEach((container) => {
        const targets = container.querySelectorAll(childSelector);
        if (!targets.length) return;

        gsap.set(targets, { autoAlpha: 0, y: 30 });
        gsap.to(targets, {
          autoAlpha: 1,
          y: 0,
          duration: 1,
          ease: 'power2.out',
          stagger: 0.12,
          scrollTrigger: { trigger: container, start: 'top 85%' },
          ...vars,
        });
      });
    }

    // 히어로 : 텍스트 없이 이미지만 진입 시 스케일업
    const heroImg = document.querySelector('.wt__hero img');
    const playHero = () => gsap.from('.wt__hero img', { scale: 1.1, duration: 1.2, ease: 'power2.out' });
    revealAni('.wt__hero__ttl', 'h1, p', { duration: 1.2, delay: 0.4 });
    if (heroImg) {
      if (heroImg.complete && heroImg.naturalWidth !== 0) {
        playHero();
      } else {
        heroImg.addEventListener('load', playHero, { once: true });
      }
    }

    // 영상 재생
    const wtVideo = document.querySelector('.wt__hero__video video');
    if (wtVideo) {
      ScrollTrigger.create({
        trigger: wtVideo,
        start: 'top 85%',
        end: 'bottom 20%',
        onEnter: () => wtVideo.play(),
      });
    }

    // 각 섹션별 타이틀 및 이미지 리빌 애니메이션
    revealAni('.wt__ttl', 'h3, p', { duration: 1.2 });

    const wtFulls = document.querySelectorAll('.wt__full');
    gsap.utils.toArray(wtFulls).forEach((el) => {
      gsap.from(el.querySelector('img'), { scale: 1.1, duration: 1.6, ease: 'power2.out', scrollTrigger: { trigger: el, start: 'top 85%' } });
    });

    const swipers = document.querySelectorAll('.wt__swiper');
    import('https://cdn.jsdelivr.net/npm/swiper@14.0.1/swiper-bundle.mjs').then(({ default: Swiper }) => {
      swipers.forEach((swiper, idx) => {
        swiper = new Swiper(swiper, {
          loop: true,
          slidesPerView: 1,
          autoplay: {
            delay: 3200,
          },
          effect: 'fade',
          speed: 650,
        });

        swiper.autoplay.stop(); // 해당 탭이 활성화될 때까지 대기

        ScrollTrigger.create({
          trigger: swiper.el,
          start: 'top bottom',
          onEnter: () => swiper.autoplay.start(),
          onLeaveBack: () => swiper.autoplay.stop(),
        });
      });
    });
  }

  // 260930 JISOO IN THE OPEN 기획전
  if ($('#htmlCustom260922').length) {
    gsap.registerPlugin(ScrollTrigger);
    let layoutRefreshTimer;
    const scheduleLayoutRefresh = () => {
      clearTimeout(layoutRefreshTimer);
      layoutRefreshTimer = setTimeout(() => ScrollTrigger.refresh(), 200);
    };
    new ResizeObserver(scheduleLayoutRefresh).observe(document.body);
    if (document.fonts) document.fonts.ready.then(scheduleLayoutRefresh);

    const isMobile = () => window.matchMedia('(max-width: 768px)').matches;

    // cover - 배경 이미지 줌아웃 & 타이틀 등장
    const heroVid = document.querySelector('.js__hero');
    const navBtns = document.querySelectorAll('.nav__btn');
    const controlsBtn = document.querySelector('.js__video__controls');
    const coverPanel = document.querySelector('.js__collection__cover--panel');
    const progressBar = document.querySelector('.js__collection__progress__bar');
    const progressFill = progressBar.querySelector('.fill');

    const HERO_VID_RATE = 0.91; // 영상 재생속도 0.9배속

    // 뷰포트 별 영상 세팅
    heroVid.poster = isMobile() ? heroVid.dataset.posterM : heroVid.dataset.poster;
    heroVid.querySelector('source').src = isMobile() ? heroVid.dataset.srcM : heroVid.dataset.src;
    heroVid.load();
    heroVid.defaultPlaybackRate = HERO_VID_RATE; // load()로 새 소스를 물리면 playbackRate가 default로 되돌아감
    heroVid.playbackRate = HERO_VID_RATE;

    const coverTl = gsap.timeline({ paused: true });
    const heroTl = gsap.timeline({ paused: true });

    // 영상 진행 위치에 따라 프로그레스바 조정
    const syncProgressToVid = () => {
      if (!heroVid.duration) return;
      gsap.set(progressFill, { width: `${(heroVid.currentTime / heroVid.duration) * 100}%` });
    };

    // 실제로 프레임 시작한 시점부터 프로그레스바 진행
    heroVid.addEventListener('playing', () => {
      gsap.ticker.remove(syncProgressToVid);
      gsap.ticker.add(syncProgressToVid);
    });
    heroVid.addEventListener('pause', () => gsap.ticker.remove(syncProgressToVid));

    coverTl
      .from('.js__collection__cover--vis', { scale: 1.3, duration: 5 }, 0)
      .to(coverPanel, { scale: 1.4, duration: 3, ease: 'power2.out' }, 0)
      .to(coverPanel, { autoAlpha: 0.4, duration: 2 }, 1.6)
      .to('.js__collection__cover--ttl', { autoAlpha: 0, duration: 0.6 }, 1.6)
      .to('.js__collection__cover--vis', { autoAlpha: 0, duration: 1, onStart: () => heroTl.play() }, 2);

    heroTl
      .call(() => heroVid.play(), null, 0)
      .from(navBtns, { y: -40, autoAlpha: 0, stagger: 0.2, duration: 0.6, ease: 'power2.out' }, 0.4)
      .from('.js__collection__progress', { y: 40, autoAlpha: 0, duration: 1, ease: 'power2.out' }, 1);

    // 탭 - VIDEO / CAMPAIGN / PRODUCTS 패널 전환
    const TAB_KEYS = ['video', 'campaign', 'products'];
    const panels = TAB_KEYS.map((key) => document.querySelector(`.js__collection__panel--${key}`));
    const pagingEls = TAB_KEYS.map((key) => document.querySelector(`.js__collection__progress__paging--${key}`));
    const swipers = []; // campaign(1) / products(2), 동적 import 이후 채워짐
    let activeIdx = 0;

    // css의 opacity:0만으론 비활성 패널이 위에 덮인 채 swiper 드래그·클릭을 가로채므로 visibility까지 내림
    gsap.set(panels.slice(1), { autoAlpha: 0 });
    navBtns[0].classList.add('on');

    // progress 영역은 탭에 따라 재생 진행바(video)와 swiper pagination(campaign/products) 중 하나만 노출
    const showProgressFor = (idx) => {
      progressBar.classList.toggle('on', idx === 0);
      pagingEls.forEach((el, i) => el && el.classList.toggle('on', i === idx));
    };
    showProgressFor(0);

    const activateTab = (idx) => {
      if (idx === activeIdx) return;

      navBtns[activeIdx].classList.remove('on');
      navBtns[idx].classList.add('on');
      gsap.to(panels[activeIdx], { autoAlpha: 0, duration: 0.6 });
      gsap.to(panels[idx], { autoAlpha: 1, duration: 0.6 });

      if (activeIdx === 0) {
        heroVid.pause();
      } else if (swipers[activeIdx]) {
        swipers[activeIdx].autoplay.stop();
      }

      activeIdx = idx;
      controlsBtn.classList.remove('pause');
      controlsBtn.style.display = 'block';
      showProgressFor(idx);

      if (idx === 0) {
        gsap.set(progressFill, { width: '0%' });
        heroVid.currentTime = 0;
        heroVid.play();

        gsap.to(coverPanel, { autoAlpha: 0.4, duration: 0.6, ease: 'none' });
        gsap.to(controlsBtn, { autoAlpha: 1, duration: 0.6, ease: 'none' });
      } else if (swipers[idx]) {
        swipers[idx].slideToLoop(0, 0);
        swipers[idx].autoplay.start();

        controlsBtn.style.display = 'none';

        gsap.to(coverPanel, { autoAlpha: 0, duration: 0.6, ease: 'none' });
      }
    };

    navBtns.forEach((btn, idx) => btn.addEventListener('click', () => activateTab(idx)));

    // 재생/일시정지 버튼 - 활성 탭에 따라 영상과 swiper autoplay 중 하나를 토글
    controlsBtn.addEventListener('click', () => {
      const resume = controlsBtn.classList.contains('pause');
      controlsBtn.classList.toggle('pause', !resume);

      if (activeIdx === 0) {
        if (resume) heroVid.play();
        else heroVid.pause();
      } else if (swipers[activeIdx]) {
        if (resume) swipers[activeIdx].autoplay.start();
        else swipers[activeIdx].autoplay.stop();
      }
    });

    // cover - 이미지 로딩 시 coverTl 실행
    const coverImg = document.querySelector('.js__collection__cover--vis img');
    const playCover = () => gsap.delayedCall(0, () => coverTl.play());
    if (coverImg && !(coverImg.complete && coverImg.naturalWidth)) coverImg.addEventListener('load', playCover, { once: true });
    else playCover();

    // Campaign / Product - Swiper
    import('https://cdn.jsdelivr.net/npm/swiper@14.0.1/swiper-bundle.mjs').then(({ default: Swiper }) => {
      [1, 2].forEach((idx) => {
        swipers[idx] = new Swiper(panels[idx], {
          loop: true,
          slidesPerView: 1,
          autoplay: {
            delay: 5500,
          },
          effect: 'fade',
          speed: 650,
          pagination: {
            el: pagingEls[idx],
            clickable: true,
          },
        });

        swipers[idx].autoplay.stop(); // 해당 탭이 활성화될 때까지 대기
      });

      // import 완료 전에 탭을 바꾸는 경우 대비
      if (activeIdx !== 0) swipers[activeIdx].autoplay.start();
    });
  }

  // 260928 플리스 기획전
  if ($('#htmlCustom260928').length) {
    gsap.registerPlugin(ScrollTrigger);

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => ScrollTrigger.refresh(), 200);
    });

    let layoutRefreshTimer;
    const scheduleLayoutRefresh = () => {
      clearTimeout(layoutRefreshTimer);
      layoutRefreshTimer = setTimeout(() => ScrollTrigger.refresh(), 200);
    };
    new ResizeObserver(scheduleLayoutRefresh).observe(document.body);
    if (document.fonts) {
      document.fonts.ready.then(scheduleLayoutRefresh);
    }

    // 여러 섹션에서 반복되는 페이드업 리빌 애니메이션
    function revealAni(containerSelector, childSelector, vars = {}) {
      gsap.utils.toArray(containerSelector).forEach((container) => {
        const targets = container.querySelectorAll(childSelector);
        if (!targets.length) return;

        gsap.set(targets, { autoAlpha: 0, y: 40 });

        gsap.to(targets, {
          autoAlpha: 1,
          y: 0,
          duration: 1,
          ease: 'power2.out',
          stagger: 0.12,
          scrollTrigger: { trigger: container, start: 'top 85%' },
          ...vars,
        });
      });
    }

    // 히어로 : 텍스트 없이 이미지만 진입 시 스케일업
    const heroImg = document.querySelector('.fleece__hero img');
    const playHero = () => gsap.to('.fleece__hero img', { scale: 1.15, duration: 1.6, ease: 'power2.out' });
    revealAni('.fleece__hero__ttl', 'h1, p', { duration: 1.2, delay: 0.4 });

    if (heroImg) {
      if (heroImg.complete && heroImg.naturalWidth !== 0) {
        playHero();
      } else {
        heroImg.addEventListener('load', playHero, { once: true });
      }
    }

    // 이미지 클립 리빌 공통 트윈
    function revealImg(img, scrollTrigger) {
      gsap.fromTo(img, { scale: 1.1 }, { scale: 1, ease: 'none', scrollTrigger });
    }

    // 가로 스크롤 pin (fleece__track이 2개라 섹션마다 실행, 셀렉터는 section 기준으로 스코핑)
    function createHorzTrack({ section, track, ttl = null, firstCount, firstRevealStart = 'top 70%', scrollRatio = 0.5 }) {
      const targets = ttl ? [track, ttl] : track;
      const dist = track.scrollWidth - window.innerWidth;
      const scrollDist = dist * scrollRatio;

      const tl = gsap
        .timeline({
          scrollTrigger: {
            trigger: section,
            pin: true,
            scrub: 0.5,
            start: 'center center',
            end: () => '+=' + scrollDist,
            invalidateOnRefresh: true,
          },
        })
        .to(targets, { x: -dist, ease: 'power1.inOut' }, 0);

      const imgs = gsap.utils.toArray(track.querySelectorAll('img, video'));
      const firstImgs = imgs.slice(0, firstCount);
      const restImgs = imgs.slice(firstCount);

      firstImgs.forEach((img) => revealImg(img, { trigger: section, start: firstRevealStart, end: 'center center' }));
      gsap.utils.toArray(section.querySelectorAll('.off')).forEach((offEl) => {
        gsap.to(offEl, {
          autoAlpha: 1,
          duration: 0.6,
          scrollTrigger: { trigger: offEl, start: 'top 20%', end: 'center 30%' },
        });
      });
      restImgs.forEach((img) => revealImg(img, { containerAnimation: tl, trigger: img, start: 'left 80%', end: 'left 40%' }));
    }

    ScrollTrigger.matchMedia({
      '(min-width: 769px)': function () {
        gsap.utils.toArray('.fleece__track').forEach((section) => {
          createHorzTrack({
            section,
            track: section.querySelector('.fleece__track__row'),
            firstCount: 2,
          });
        });

        gsap.to('.fleece__zip__item--3 .full', {
          xPercent: -100,
          duration: 1,
          ease: 'none',
          scrollTrigger: { trigger: '.fleece__zip__item--3', start: 'top 20%' },
        });
      },

      '(max-width: 768px)': function () {
        gsap.utils.toArray('.fleece__track').forEach((section) => {
          createHorzTrack({
            section,
            track: section.querySelector('.fleece__track__row'),
            firstCount: 1,
            scrollRatio: 1.2,
          });
        });

        gsap.to('.fleece__zip__swiper .full img', {
          xPercent: -50,
          duration: 1,
          ease: 'none',
          scrollTrigger: { trigger: '.fleece__zip__swiper', start: 'top 50%' },
        });
      },
    });

    gsap.to('.fleece__zip__item--1 .off', {
      autoAlpha: 1,
      duration: 0.6,
      scrollTrigger: { trigger: '.fleece__zip__item--1 .off', start: 'top 50%', end: 'center 30%' },
    });

    import('https://cdn.jsdelivr.net/npm/swiper@14.0.1/swiper-bundle.mjs').then(({ default: Swiper }) => {
      const mq = window.matchMedia('(max-width: 768px)');
      let zipSwiper = null;

      function enter() {
        if (zipSwiper) return;
        zipSwiper = new Swiper('.fleece__zip__swiper', {
          autoplay: {
            delay: 4000,
          },
          speed: 650,
          slidesPerView: 1,
          pagination: {
            el: '.fleece__zip__swiper .swiper-pagination',
            clickable: true,
          },
        });
      }

      function exit() {
        if (!zipSwiper) return;
        zipSwiper.destroy(true, true);
        zipSwiper = null;
      }

      mq.addEventListener('change', (e) => (e.matches ? enter() : exit()));
      if (mq.matches) enter();
    });

    window.addEventListener('load', () => ScrollTrigger.refresh());
  }

  // 260907 GTWS 훈련대비 기획전
  if ($('#htmlCustom260907').length) {
    gsap.registerPlugin(ScrollTrigger);

    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => ScrollTrigger.refresh(), 200);
    });

    // 여러 섹션에서 반복되는 페이드업 리빌 패턴 - 컨테이너 기준으로 스코핑
    function revealChildren(containerSelector, childSelector, vars = {}) {
      gsap.utils.toArray(containerSelector).forEach((container) => {
        const targets = container.querySelectorAll(childSelector);
        if (!targets.length) return;

        gsap.from(targets, {
          autoAlpha: 0,
          y: 40,
          duration: 1,
          ease: 'power2.out',
          scrollTrigger: { trigger: container, start: 'top 85%' },
          ...vars,
        });
      });
    }

    // 히어로 단락 모션
    const heroTl = gsap.timeline({ paused: true });
    gsap.set('.gtws__hero img', { scale: 1.1 });
    gsap.set('.gtws__hero__ttl', { autoAlpha: 0 });
    gsap.set('.gtws__hero__ttl h1', { autoAlpha: 0, y: 40 });

    heroTl.to('.gtws__hero img', { scale: 1, duration: 1, ease: 'power2.out' }, 0).to('.gtws__hero__ttl', { autoAlpha: 1, duration: 0.5 }, 0).to('.gtws__hero__ttl h1', { autoAlpha: 1, y: 0 }, 0.5);

    gsap.from('.gtws__course__ttl', { y: 40, autoAlpha: 0, duration: 1.2, scrollTrigger: { trigger: '.gtws__course__ttl', start: 'top 80%' } });

    // 코스 안내 영상 : 화면에 들어올 때만 재생
    const courseVideo = document.querySelector('.gtws__course__vid video');
    if (courseVideo) {
      ScrollTrigger.create({
        trigger: courseVideo,
        start: 'top 85%',
        end: 'bottom 20%',
        onEnter: () => courseVideo.play(),
      });
    }

    revealChildren('.gtws__ttl', 'h3, p');
    revealChildren('.gtws__course__lst', '.swiper-slide', { stagger: 0.15 });

    // 대회 준비 타임라인
    revealChildren('.gtws__timeline', '.gtws__timeline__ttl, .gtws__timeline__controls, .gtws__timeline__slide');

    import('https://cdn.jsdelivr.net/npm/swiper@14.0.1/swiper-bundle.mjs').then(({ default: Swiper }) => {
      const slideEl = document.querySelector('.gtws__timeline__slide');
      if (!slideEl) return;

      new Swiper(slideEl, {
        slidesPerView: 'auto',
        grabCursor: true,
        breakpoints: {
          0: { spaceBetween: 12 },
          768: { spaceBetween: 20 },
        },
        navigation: {
          nextEl: '.gtws__timeline__btn--next',
          prevEl: '.gtws__timeline__btn--prev',
          disabledClass: 'disabled',
        },
      });
    });

    // 필수 장비 목록
    revealChildren('.gtws__items', '.gtws__items__table, .noti', { y: 30 });

    // 리뷰 이벤트 배너
    gsap.from('.gtws__review strong, .gtws__review p', {
      autoAlpha: 0,
      y: 20,
      duration: 0.8,
      ease: 'power2.out',
      scrollTrigger: { trigger: '.gtws__review', start: 'top 70%' },
    });

    gsap.from('.gtws__review', {
      backgroundPosition: '50% 100%',
      ease: 'power2.out',
      scrollTrigger: { trigger: '.gtws__review', start: 'top 55%', scrub: 0.1 },
    });

    // EVENT 단락
    gsap.from('.event__inner > h2', {
      autoAlpha: 0,
      y: 20,
      duration: 0.8,
      ease: 'power2.out',
      scrollTrigger: { trigger: '.event__inner > h2', start: 'top 90%' },
    });
    revealChildren('.event__col', '.event__ttl, .event__gift, .event__info, .noti');

    (function () {
      var mq = window.matchMedia('(max-width: 768px)');
      var seriesSwiper = null;

      function enter() {
        if (seriesSwiper) return;
        seriesSwiper = new Swiper('.gtws__course__lst', {
          slidesPerView: 1,
          spaceBetween: 20,
          pagination: {
            el: '.gtws__course__lst .swiper-pagination',
            clickable: true,
          },
        });
      }

      function exit() {
        if (!seriesSwiper) return;
        seriesSwiper.destroy(true, true);
        seriesSwiper = null;
      }

      mq.addEventListener('change', (e) => (e.matches ? enter() : exit()));
      if (mq.matches) enter();
    })();

    // Hero 단락 타임라인 실행
    var heroImg = document.querySelector('.pt__hero img');
    var playHeroTl = function () {
      gsap.delayedCall(0.5, () => heroTl.play());
    };
    if (heroImg) {
      if (heroImg.complete && heroImg.naturalWidth !== 0) {
        playHeroTl();
      } else {
        heroImg.addEventListener(
          'load',
          () => {
            playHeroTl();
            ScrollTrigger.refresh();
          },
          { once: true }
        );
      }
    } else {
      playHeroTl();
    }
  }
  
  //260713 XT-ICONS 기획전
  if ($('#htmlCustom260713').length) {
    publisherInitScrollReveal();
  }

  //260422 쇼츠 리뷰 기획전
  if($('#htmlCustom260422').length){
    publisherCustomScrollEvent();
    
    $(window).on('load scroll', function(){
      publisherCustomTabSticky();
    });

    var swiper = new Swiper(".swiper-wrap .swiper-container", {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      autoplay: {
          delay: 1800,
          pauseOnMouseEnter: true,
          disableOnInteraction: false,
      },
      speed: 600,  // 전환 속도
    });
  }

  //260408 그래블어패럴 기획전
  if($('#htmlCustom260408').length){
    gsap.registerPlugin(ScrollTrigger);

    // 모바일에서만 실행
    if (window.innerWidth < 768) {
      const track = document.querySelector('.h-track');
      const wrap = document.querySelector('.h-wrap');

      // h-track 너비를 디바이스 너비의 2배로 설정
      track.style.width = (window.innerWidth * 2) + 'px';

      gsap.to(track, {
        x: () => -(track.scrollWidth - window.innerWidth),
        ease: 'none',
        scrollTrigger: {
          trigger: '.is-horizontal',
          start: 'top top',
          end: () => '+=' + (track.scrollWidth - window.innerWidth),
          pin: true,
          scrub: true,
          anticipatePin: 1,
        }
      });
    }
    
    $('.img-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      speed: 600,
      autoplay: true,
      autoplaySpeed: 600,
      arrows: false,
      fade: true,
      cssEase: 'linear',
      pauseOnHover: false,
    });

    //scroll motion
    $(window).on('load scroll', function(){
      $('.section-visual, .box, .section-btm').each(function(){
        const rect = $(this)[0].getBoundingClientRect();

        if (rect.top <= window.innerHeight * 0.8) {
          $(this).addClass('active');
        }
      });
    });
  }

  //260327 진도 기획전
  if($('#htmlCustom260327').length){
    $('.img-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      speed: 800,
      autoplay: true,
      autoplaySpeed: 1200,
      arrows: false,
      fade: true,
      cssEase: 'linear',
      pauseOnHover: false,
    });
    //scroll motion
    $(window).on('load scroll', function(){
      $('.section-visual h1').each(function(){
        const rect = $(this)[0].getBoundingClientRect();

        if (rect.top <= window.innerHeight * 1) {
          $(this).addClass('active');
        }
      });
      $('.box-img, .txt').each(function(){
        const rect = $(this)[0].getBoundingClientRect();

        if (rect.top <= window.innerHeight * 0.7) {
          $(this).addClass('active');
        }
      });
    });
  }

  //260309 팬츠 리뷰 기획전
  if($('#htmlCustom260309').length){
    publisherCustomScrollEvent();
    
    $(window).on('load scroll', function(){
      publisherCustomTabSticky();
    });

    var swiper = new Swiper(".swiper-wrap .swiper-container", {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      autoplay: {
          delay: 1800,
          pauseOnMouseEnter: true,
          disableOnInteraction: false,
      },
      speed: 600,  // 전환 속도
      pagination: {
        el: ".swiper-pagination",
      },
    });
  }
  
  //260304 그래블러닝 기획전
  if($('#htmlCustom260304').length){
    gsap.registerPlugin(ScrollTrigger);

    let sections = gsap.utils.toArray(".section-pin .section-item");
    sections.forEach((section, index, array) => {
      const isH = section.classList.contains("is-horizontal");

      if (isH) {
        const track = section.querySelector(".h-track");
        const slides = track ? section.querySelectorAll(".h-slide") : [];

        if (!track || slides.length <= 1) return;

        gsap.to(track, {
          xPercent: -100 * (slides.length - 1),
          ease: "none",
          scrollTrigger: {
            trigger: section,
            start: "top top",
            end: () => "+=" + window.innerWidth * (slides.length - 1),
            pin: true,
            pinSpacing: true,
            scrub: true,
            invalidateOnRefresh: true
          }
        });
      } else {
        ScrollTrigger.create({
          trigger: section,
          start: "top top",
          end: () => "+=" + section.offsetHeight,
          pin: true,
          pinSpacing: (index === array.length - 1) ? true : false,
          scrub: true,
          invalidateOnRefresh: true
          // markers: true,
        });
      }
    });

    //scroll motion
    $(window).on('load scroll', function(){
      $('.section-visual').each(function(){
        const rect = $(this)[0].getBoundingClientRect();

        if (rect.top <= window.innerHeight * 0.5) {
          $(this).addClass('active');
        }
      });
    });

    //scroll motion
    $(window).on('load scroll', function(){
      $('.section-visual').each(function(){
        const rect = $(this)[0].getBoundingClientRect();

        if (rect.top <= window.innerHeight * 0.5) {
          $(this).addClass('active');
        }
      });
    });
  }

  //260213 트레일러닝기획전 
  if($('#htmlCustom260213').length){
    var swiper = new Swiper('.swiper-container', {
      slidesPerView: 1,
      spaceBetween: 0,
      freeMode: true,
      freeModeMomentum: true,
      freeModeMomentumRatio: 0.5,
      freeModeMomentumVelocityRatio: 0.5,
      mousewheel: true,
    });
    //scroll motion
    $(window).on('load scroll', function(){
      $('.scroll-motion').each(function(){
        const rect = $(this)[0].getBoundingClientRect();

        if (rect.top <= window.innerHeight * 0.5) {
          $(this).addClass('active');
        }
      });
    });
  }

  //260204 XT위스퍼기획전
  if($('#htmlCustom260204').length){
    $('.img-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      speed: 0,
      autoplay: true,
      autoplaySpeed: 1000,
      arrows: false,
      fade: true,
      cssEase: 'linear',
      pauseOnHover: false,
    });
    //scroll motion
    $(window).on('load scroll', function(){
      $('.scroll-motion').each(function(){
        const rect = $(this)[0].getBoundingClientRect();

        if (rect.top <= window.innerHeight * 0.5) {
          $(this).addClass('active');
        }
      });
    });
  }

  //260122 어드밴스드 기획전
  if($('#htmlCustom260122-2').length){
    $('.img-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      speed: 800,
      autoplay: true,
      autoplaySpeed: 1000,
      arrows: false,
      fade: true,
      cssEase: 'linear',
      pauseOnHover: false,
    });
  }

  //260122 XT퀘스트기획전
  if($('#htmlCustom260122').length){
    const swiper = new Swiper('.swiper', {
      slidesPerView: 3.3,
      spaceBetween: 14,
      loop: false,
      autoplay: {
          delay: 800,
          disableOnInteraction: false,
      },
      speed: 1000,
      breakpoints: {
        767: {
          slidesPerView: 1.6,
          spaceBetween: 7,
        }
      }
    });
  }

  //260116 판타즘3출시기획전
  if($('#htmlCustom260116').length){
    //scroll motion
    $(window).on('load scroll', function(){
      $('[class^="group"]').each(function(){
        const rect = $(this)[0].getBoundingClientRect();

        if (rect.top <= window.innerHeight * 0.5) {
          $(this).addClass('active');
        }
      });
    });
  }

  //260107 녹턴비전 기획전
  if($('#htmlCustom260107-2').length){
    const swiper = new Swiper('.swiper', {
      slidesPerView: 3.3,
      spaceBetween: 16,
      loop: false,
      autoplay: {
          delay: 800,
          disableOnInteraction: false,
      },
      speed: 1000,
      breakpoints: {
        767: {
          slidesPerView: 1.8,
        }
      }
    });
  }

  //260107 아이콘캡슐 기획전
  if($('#htmlCustom260107').length){
    $('.img-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      speed: 800,
      autoplay: true,
      autoplaySpeed: 1600,
      arrows: false,
      fade: true,
      cssEase: 'linear',
      pauseOnHover: false,
    });
  }

  //251224 스키용품기획전
  if($('#htmlCustom251224').length){
    $('.promo-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,

      // PC 기본: 스와이프/드래그 비활성
      swipe: false,
      draggable: false,
      touchMove: false,
      autoplay: false,

      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            // 모바일: 스와이프/드래그 활성
            swipe: true,
            draggable: true,
            touchMove: true,
            autoplay: true,
            autoplaySpeed: 2000,
            pauseOnHover: false,
            pauseOnFocus: false
          }
        }
      ]
    });
  }

  //251215 슬레이트기획전
  if($('#htmlCustom251215-2').length){
    const swiper = new Swiper('.swiper', {
      slidesPerView: 2,
      spaceBetween: 0,
      loop: false,
      autoplay: {
        delay: 2000,
        disableOnInteraction: false,
      },
      speed: 1200,
      breakpoints: {
        767: {
          slidesPerView: 1,
          spaceBetween: 0,
        }
      }
    });
  }
  
  //251215 컨투어다운리뷰기획전
  if($('#htmlCustom251215').length){
    const swiper = new Swiper('.swiper', {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      autoplay: {
          delay: 1000,
          disableOnInteraction: false,
      },
      speed: 1200,
      effect: 'fade'
    });
    //scroll motion
    $(window).on('load scroll', function(){
      $('.txt-motion').each(function(){
        const rect = $(this)[0].getBoundingClientRect();

        if (rect.top <= window.innerHeight * 0.7) {
          $(this).addClass('active');
        }
      });
    });
  }

  //251119 스키 기획전
  if($('#htmlCustom251119-3').length){
    document.querySelectorAll('[class^="section-scroll"]').forEach(area => {
      const content = area.querySelector('.scroll-wrap');
      const bar = area.querySelector('.scroll-bar');
      const barWidth = bar.offsetWidth;

      content.addEventListener('scroll', () => {
        const max = content.scrollWidth - content.clientWidth;
        const percent = content.scrollLeft / max;
        const move = (content.clientWidth - barWidth) * percent;
        bar.style.transform = `translateX(${move}px)`;
      });
    });
  }

  //251119 윈터러닝 기획전
  if($('#htmlCustom251119-1').length){
    let sections = gsap.utils.toArray(".section-scroll");
    sections.forEach((section, index, array) => {
      ScrollTrigger.create({
        trigger: section,
        start: "top top",
        end: () => "+=" + section.offsetHeight, 
        pin: true,
        pinSpacing: (index === array.length - 1) ? true : false,
        scrub: true,
        markers: false,
        invalidateOnRefresh: true
      });
    });

    const swiper251119 = new Swiper('.section-visual .swiper', {
      slidesPerView: 2.5,
      spaceBetween: 0,
      loop: true,
      loopAdditionalSlides: 5,
      autoplay: {
        delay: 800,
        disableOnInteraction: false,
      },
      speed: 1000,
      breakpoints: {
        767: {
          slidesPerView: 1,
          spaceBetween: 0
        }
      }
    });
  }
  
  //251110 아이콘 슈즈 기획전
  if($('#htmlCustom251110').length){
    const swiper = new Swiper('.swiper', {
      slidesPerView: 3.5,
      spaceBetween: 20,
      loop: true,
      autoplay: {
          delay: 800,
          disableOnInteraction: false,
      },
      speed: 1000,
      breakpoints: {
        767: {
          slidesPerView: 2,
          spaceBetween: 6,
        }
      }
    });
    //scroll motion
    $(window).on('load scroll', function(){
      $('.section-visual').each(function(){
        const rect = $(this)[0].getBoundingClientRect();

        if (rect.top <= window.innerHeight * 0.5) {
          $(this).addClass('active');
        }
      });
      $('.section-slide').each(function(){
        const rect = $(this)[0].getBoundingClientRect();

        if (rect.top <= window.innerHeight * 0.7) {
          $(this).addClass('active');
        }
      });
      $('.item').each(function(){
        const rect = $(this)[0].getBoundingClientRect();

        if (rect.top <= window.innerHeight * 0.5) {
          $(this).addClass('active');
        }
      });
    });
  }
  
  //251027 해비다운 기획전
  if($('#htmlCustom251027').length){
     $('.slick').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: true,
      speed: 600,
      autoplay: true,
      autoplaySpeed: 1000,
      arrows: false,
      dots: true,
      fade: true,
      cssEase: 'linear'
    });
    //scroll motion
    $(window).on('load scroll', function(){
      $('.img-wrap').each(function(){
        const rect = $(this)[0].getBoundingClientRect();

        if (rect.top <= window.innerHeight * 0.4) {
          $(this).addClass('active');
        }
      });
      $('.txt-wrap').each(function(){
        const rect = $(this)[0].getBoundingClientRect();

        if (rect.top <= window.innerHeight * 0.8) {
          $(this).addClass('active');
        }
      });
    });
  }
  
  //251001 컨투어 자켓 기획전
  if($('#htmlCustom251001').length){
    const swiper = new Swiper('.section-banner .swiper-container', {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 700,
        autoplay: {
          delay: 2000,
          disableOnInteraction: false
        },
        pagination: {
          el: '.section-banner .swiper-pagination',
          type: 'progressbar'
        },

        keyboardControl: true,
        grabCursor: true,
        resistanceRatio: 0.6
    });
    const swiper2 = new Swiper('.section-prd .swiper-container', {
        centeredSlides: true,
        slidesPerView: 4.1,
        spaceBetween: 10,
        loop: true,
        autoplay: {
            delay: 800,
            pauseOnMouseEnter: true,
            disableOnInteraction: false,
        },
        speed: 600,
        breakpoints: {
          767: {
            slidesPerView: 2.1,
            spaceBetween: 5,
          }
        }
    });
    //scroll motion
    $(window).on('load scroll', function(){
      $('.section-prd').each(function(){
        const rect = $(this)[0].getBoundingClientRect();

        if (rect.top <= window.innerHeight * 0.6) {
          $(this).addClass('active');
        }
      });
    });
  }

  //250910 그래블러닝 기획전
  if($('#htmlCustom250910').length){
     const swiper = new Swiper('.section-about .swiper', {
      slidesPerView: "auto",
      spaceBetween: 20,
      loop: true,
      autoplay: {
          delay: 800,
          pauseOnMouseEnter: true,
          disableOnInteraction: false,
      },
      speed: 600,
      breakpoints: {
        767: {
          slidesPerView: 1,
          centeredSlides: true,
        }
      }
    });
    const swiper2 = new Swiper('.section-lineup .swiper', {
      slidesPerView: 3,
      spaceBetween: 25,
      loop: true,
      autoplay: {
          delay: 800,
          pauseOnMouseEnter: true,
          disableOnInteraction: false,
      },
      speed: 800,
      breakpoints: {
        767: {
          slidesPerView: 2,
          spaceBetween: 13,
        }
      }
    });
    // 마우스 오버 시 정지
    document.querySelector('.section-lineup .swiper').addEventListener('mouseenter', function () {
      if (swiper2.stopAutoplay) {
        swiper2.stopAutoplay();
      } else {
        swiper2.autoplay.stop();
      }
    });
    // 마우스 아웃 시 재시작
    document.querySelector('.section-lineup .swiper').addEventListener('mouseleave', function () {
      if (swiper2.startAutoplay) {
        swiper2.startAutoplay();
      } else {
        swiper2.autoplay.start();
      }
    });
    //scroll motion
    $(window).on('load scroll', function(){
      $('.section-about').each(function(){
        const rect = $(this)[0].getBoundingClientRect();

        if (rect.bottom <= window.innerHeight * 0.9) {
          $(this).addClass('active');
        }
      });
      $('.section-run [class^="group"]').each(function(){
        const rect = $(this)[0].getBoundingClientRect();

        if (rect.top <= window.innerHeight * 0.6) {
          $(this).addClass('active');
        }
      });
      $('.section-run .right .box2').each(function(){
        const rect = $(this)[0].getBoundingClientRect();

        if (rect.top <= window.innerHeight * 0.3) {
          $(this).addClass('active');
        }
      });
      $('.section-run .left .box3').each(function(){
        const rect = $(this)[0].getBoundingClientRect();

        if (rect.top <= window.innerHeight * 0.5) {
          $(this).addClass('active');
        }
      });
      $('.section-run .mobile-only .box').each(function(){
        const rect = $(this)[0].getBoundingClientRect();

        if (rect.top <= window.innerHeight * 0.8) {
          $(this).addClass('active');
        }
      });
    });
  }
  //250905 모디세이기획전
  if($('#htmlCustom250905').length){
    const swiper = new Swiper('.swiper-section', {
      loop: true,
      autoplay: {
          delay: 800,
          pauseOnMouseEnter: false,
          disableOnInteraction: false,
      },
      speed: 600,
      pagination: {
        el: ".swiper-pagination",
        type: "fraction",
      },
    });


    $(window).on('load scroll', function(){
      $('[class^="visual"]').each(function(){
          const rect = $(this)[0].getBoundingClientRect();

          if (rect.top <= window.innerHeight * 0.5) {
              $(this).addClass('active');

          }
      });
    });
  }
});
